import AnalyticsReactContext from '@atlaskit/analytics-next-stable-react-context';

export type { AnalyticsReactContextInterface } from '@atlaskit/analytics-next-stable-react-context';

export default AnalyticsReactContext;
